import axios from 'axios';

// Ensure you have a .env.local file in your project root with these variables:
// REACT_APP_API_URL=https://your-api-id.execute-api.us-east-1.amazonaws.com/prod
// REACT_APP_API_KEY=yoursecureapikey
// These are injected during the build process from Gitlab CI variables

// Create a dedicated axios instance for our API. This is a best practice.
const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-Type': 'application/json',
        // The API Key is sent in this header, as configured in API Gateway.
        'x-api-key': process.env.REACT_APP_API_KEY,
    },
});

/**
 * Sends the barcode data to the backend to generate a Google Wallet pass.
 * @param {string} barcode The barcode data scanned or entered by the user.
 * @returns {Promise<Object>} A promise that resolves with the API response data.
 */
export const generatePass = (barcode) => {
    // The backend expects the data in a specific JSON format.
    const payload = {
        barcodeData: barcode,
    };

    // Make the POST request to the /passes endpoint.
    // The full URL will be: ${REACT_APP_API_URL}/passes
    return apiClient.post('/passes', payload);
};
